import { render } from "./MainReportSales.vue?vue&type=template&id=25d6711b&scoped=true"
import script from "./MainReportSales.vue?vue&type=script&lang=js"
export * from "./MainReportSales.vue?vue&type=script&lang=js"

import "./MainReportSales.vue?vue&type=style&index=0&id=25d6711b&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d6711b"]])

export default __exports__